import React, { Component } from 'react';

import followIconNoProfilePic from '../assets/images/profile-pic.svg'
import moment from 'dayjs';

class NotificationListItem extends Component{
  getNotificationLink = () => {
    const { notification } = this.props
    const link = notification?.link

    //NOTE: cause we removed /my-account route and replaced it with /author/:id, we need to check if the link is /my-account and replace it with the correct author link cause they are in the Database with /my-account link. We can remove this check once we have migrated all the old notifications to have the correct author link.
    if (link === '/my-account') {
      const userId = notification?.user?.id || notification?.notificationUserId
      return userId ? `/author/${encodeURIComponent(userId)}` : '/notification'
    }

    return link
  }

  getNotificationIcon = () => {
    const { notification } = this.props
    const photoURL = notification?.actionUser?.photoURL

    if (!photoURL) return followIconNoProfilePic
    if (photoURL.includes('/static/media/avocado.')) {
      return `${process.env.PUBLIC_URL}/images/avocado.svg`
    }
    if (photoURL.includes('/static/media/watermelon-icon.')) {
      return `${process.env.PUBLIC_URL}/images/watermelon-icon.svg`
    }

    return photoURL
  }

  handleIconError = (event) => {
    event.currentTarget.onerror = null
    event.currentTarget.src = followIconNoProfilePic
  }

  readNotification = () => {
    const { notification, readNotification, history } = this.props
    if(!notification.read) {
      readNotification(notification.id)
    }
    history.push(this.getNotificationLink())
  }

  render() {
    const { notification } = this.props

    return(
      <div onClick={this.readNotification} className={`notification-list-item trackit ${notification.read ? "" : "unread"}`} id={"notification_list_item_" + notification.id}>
        <div className="author">
          <img
            src={this.getNotificationIcon()}
            onError={this.handleIconError}
            className="profile-pic"
            alt="Notification icon"
          />
        </div>
        <div>
          <code><b>{notification.actionUser.displayName || notification.actionUser.userID}</b></code> {notification.content}.
          <br />
          <time>{moment(notification.createdAt).fromNow()}</time>
        </div>
        <div>
          <span className="badge badge--grey">{notification.category}</span>
        </div>
      </div>
    )
  }
}

export default NotificationListItem
